import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { TeamResponse } from 'src/app/models/TeamResponse';
import { CommonResponse } from 'src/app/models/commomResponse';
import { driverData } from 'src/app/models/driverData';
import { ExportCsvResponse } from 'src/app/models/exportCsvResponst';
import { OrderDetail } from 'src/app/models/orderDetail';
import { orderToDriver, orderUpdatePayload } from 'src/app/models/orderPayload';
import { OrderResponse } from 'src/app/models/orderResponse';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class OrderService {
  constructor(private http: HttpClient) { }

  getOrder(query: string): Observable<OrderResponse> {
    return this.http
      .get<{ data: OrderResponse }>(`${environment.base_url}getOrders?${query}`)
      .pipe(map(res => res.data));
  }

  getreturnRequest(query: string): Observable<OrderResponse> {
    return this.http
      .get<{
        data: OrderResponse;
      }>(`${environment.base_url}returnRequest?${query}`)
      .pipe(map(res => res.data));
  }

  getTeams(): Observable<Array<TeamResponse>> {
    return this.http
      .get<{
        data: Array<TeamResponse>;
      }>(`${environment.base_url}teamsDropdown`)
      .pipe(map(res => res.data));
  }

  updateOrder(
    orderId: string,
    body: orderUpdatePayload
  ): Observable<OrderDetail> {
    return this.http
      .put<{
        data: OrderDetail;
      }>(`${environment.operational_url}updateOrder/${orderId}? `, body)
      .pipe(map(res => res.data));
  }

  assignDriver(
    orderId: string,
    body: { driverId: string; bookingForReturnDriver?: boolean }
  ): Observable<CommonResponse> {
    return this.http
      .post<{
        data: CommonResponse;
      }>(`${environment.operational_url}assignOrder/${orderId}`, body)
      .pipe(map(res => res.data));
  }

  getDriversByTeam(id: string): Observable<{ data: Array<driverData> }> {
    return this.http.get<{ data: Array<driverData> }>(
      `${environment.base_url}driversThroughTeam/${id}`
    );
  }

  assignOrderToDriver(
    payload: orderToDriver,
    orderId: string
  ): Observable<CommonResponse> {
    return this.http.post<CommonResponse>(
      `${environment.base_url}assignDriver/${orderId}`,
      payload
    );
  }

  exportCsv(query: string): Observable<ExportCsvResponse> {
    return this.http.get<ExportCsvResponse>(
      `${environment.base_url}admin/getOrdersCsvExport?${query}`
    );
  }

  invoice(orderId: string): Observable<any> {
    return this.http.get<any>(`${environment.operational_url}invoice/${orderId}`);
  }

  updateQualityCheck(body: any, id: string): Observable<OrderDetail> {
    return this.http.post<OrderDetail>(
      `${environment.base_url}/factory/orders/${id}/return-qc`,
      body
    );
  }

  // Substitute Product APIs
  getSubstituteProducts(
    orderId: string,
    page: number = 1,
    limit: number = 12,
    search: string = ''
  ): Observable<{ data: { substituteProduct: any[]; totleCount: number } }> {
    const query = `page=${page}&limit=${limit}${search ? `&search=${search}` : ''}`;
    return this.http.get<{ data: { substituteProduct: any[]; totleCount: number } }>(
      `${environment.base_url}substituteProduct/${orderId}?${query}`
    );
  }

  updateSubstituteProduct(
    orderId: string,
    body: { productId?: string; variantId?: string; quantity?: number; status?: number }
  ): Observable<CommonResponse> {
    return this.http.put<CommonResponse>(
      `${environment.base_url}substituteProduct/${orderId}`,
      body
    );
  }

  sendSubstituteNotification(
    orderId: string,
    products: { productId: string; variantId: string | null; quantity: number }[]
  ): Observable<CommonResponse> {
    return this.http.post<CommonResponse>(
      `${environment.base_url}sendSubstituteNotification`,
      { subOrderId:orderId, products }
    );
  }
}
